/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import { useTheme } from 'styled-components'
import { useSession, useOrder, useLanguage, useConfig, AddressForm as AddressFormController } from '~components'
import CgSearchLoading from '@meronex/icons/cg/CgSearchLoading'
import { useLocation } from 'react-router-dom'
import {
  Alert,
  Modal,
  AddressForm,
  LoginForm,
  SignUpForm,
  ForgotPasswordForm,
  AddressList,
  CartContent,
  Button
} from '~ui'
import { GoogleGpsButtonHome } from '../GoogleGpsButtonHome'
import { useForm } from 'react-hook-form'
import logoImg from '../../../../assets/images/newimage/logo.svg'
import {
  BlackContainer,
  MainSection,
  HeroTitle,
  HeroSubtitle,
  SearchSection,
  SearchWrap,
  SearchInput,
  AddressUseLocation,
  ActionButtons,
  CyanButton,
  AgeVerificationWrapper,
  AgeVerificationTitle,
  AgeVerificationDesc,
  AgeVerificationButton
} from './styles'

import MdLocationOn from '@meronex/icons/md/MdLocationOn'
import BiSearchAlt2 from '@meronex/icons/bi/BiSearchAlt2'
import bottleBg from '../../../../assets/images/bottlebg.png'
import bgmobile from '../../../../assets/images/bgmobile.png'
import FaWhatsapp from '@meronex/icons/fa/FaWhatsapp'
import FaPhoneAlt from '@meronex/icons/fa/FaPhoneAlt'

const inputNames = [
  { name: 'address', code: 'Address' },
  { name: 'internal_number', code: 'Internal number' },
  { name: 'zipcode', code: 'Zipcode' },
  { name: 'address_notes', code: 'Address notes' }
]
export const HomeHeroUI = (props) => {
  const { onFindBusiness, notificationState, formState, saveAddress, updateChanges } = props
  const location = useLocation()
  const [{ auth, loading: sessionLoading }, { login }] = useSession()
  const [orderState] = useOrder()
  const [, t] = useLanguage()
  const [modals, setModals] = useState({ listOpen: false, formOpen: false })
  const theme = useTheme()
  const [configState] = useConfig()
  const userCustomer = parseInt(window.localStorage.getItem('user-customer'))
  const [authModalOpen, setAuthModalOpen] = useState(false)
  const [modalPageToShow, setModalPageToShow] = useState(null)
  const [newAddressModalOpened, setNewAddressModalOpened] = useState(false)
  const [isGPSAddress, setIsGPSAddress] = useState(false)
  const maxLimitLocation = configState?.configs?.meters_to_change_address?.value
  const googleMapsApiKey = configState?.configs?.google_maps_api_key?.value
  const [alertState, setAlertState] = useState({ open: false, content: [] })
  const [shouldFindBusiness, setShouldFindBusiness] = useState(false)
  const [locsearch, setLocsearch] = useState(false)
  const [ageVarificationPop, setAgeVarificationPop] = useState(false)
  const carts = (orderState?.carts && Object.values(orderState?.carts).filter(cart => (cart.products && cart.products?.length > 0) || cart?.reservation)) || null
  const googleInputRef = useRef()
  const formMethods = useForm()
  const mapErrors = {
    ERROR_NOT_FOUND_ADDRESS: 'Sorry, we couldn\'t find an address',
    ERROR_MAX_LIMIT_LOCATION: `Sorry, You can only set the position to ${maxLimitLocation}m`
  }
  const setMapErrors = (errKey) => {
    setAlertState({
      open: true,
      content: !(errKey === 'ERROR_MAX_LIMIT_LOCATION')
        ? [t(errKey, mapErrors[errKey])]
        : `${[t(errKey, mapErrors[errKey])]} ${maxLimitLocation} ${[t('METTERS', 'meters')]}`
    })
  }
  const closeAlert = () => {
    setAlertState({
      open: false,
      content: []
    })
  }
  const onSubmitGeolocation = () => {
    console.log('address', formState?.changes?.address)
    if (formState?.changes?.address && !formState?.changes?.location) {
      return
    }
    console.log('location', formState?.changes?.location)
    saveAddress()
    setLocsearch(false)
    onFindBusiness && onFindBusiness()
  }
  const handleChangeAddress = (address, forceUpdate) => {
    console.log('address', address?.address)
    setShouldFindBusiness(true)
    updateChanges({
      ...address,
      address: forceUpdate
        ? address?.address
        : (googleInputRef?.current?.value || address?.address)
    })

    inputNames.forEach(field => {
      if (address[field.name] !== undefined) {
        formMethods.setValue(field.name, address[field.name] ?? '')
      }
    })

    if (forceUpdate && googleInputRef.current) {
      googleInputRef.current.value = address?.address
    }
  }
  const handleGpsGeocode = (location) => {
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({ location }, (results, status) => {
      if (status === 'OK' && results && results.length > 0) {
        const addressObj = {}
        for (const component of results[0].address_components) {
          const addressType = component.types[0]
          if (addressType === 'postal_code') addressObj.zipcode = component.short_name
          if (addressType === 'street_number') addressObj.street_number = component.long_name
          if (addressType === 'neighborhood') addressObj.neighborhood = component.long_name
          if (addressType === 'route') addressObj.route = component.long_name
          if (addressType === 'locality') {
            addressObj.city = component.long_name
            addressObj.locality = component.long_name
          }
          if (addressType === 'country') {
            addressObj.country = component.long_name
            addressObj.country_code = component.short_name
          }
          if (addressType === 'administrative_area_level_1') {
            addressObj.state = component.long_name
            addressObj.state_code = component.short_name
          }
        }
        const address = {
          address: results[0].formatted_address,
          location,
          utc_offset: (new Date()).getTimezoneOffset(),
          map_data: {
            library: 'google',
            place_id: results[0].place_id
          },
          ...addressObj
        }
        formMethods.setValue('address', address.address)
        handleChangeAddress(address, true)
      } else {
        setMapErrors('ERROR_NOT_FOUND_ADDRESS')
      }
    })
  }

  const handleFindBusinesses = () => {
    if (!orderState?.options?.address?.location) {
      setModals({ ...modals, formOpen: true })
      return
    }
    window.sessionStorage.setItem('force_enter_first_business', 'true')
    setModals({ listOpen: false, formOpen: false })
    onFindBusiness && onFindBusiness()
    setShouldFindBusiness(false)
  }

  const handleAddressInput = () => {
    if (auth) {
      setModals({ ...modals, listOpen: true })
    } else {
      setModals({ ...modals, formOpen: true })
    }
  }

  const handleCustomModalClick = (e, { page }) => {
    e.preventDefault()
    setModalPageToShow(page)
  }

  const closeAuthModal = () => {
    setAuthModalOpen(false)
    setModalPageToShow(null)
  }

  const handleSuccessLogin = (user) => {
    if (user) {
      closeAuthModal()
    }
  }

  const handleSuccessSignup = (user) => {
    login({
      user,
      token: user?.session?.access_token
    })
  }
  useEffect(() => {
    const params = new URLSearchParams(location.search)

    const lat = params.get('lat')
    const lng = params.get('lng')
    const seraddress = params.get('address')

    if (!(lat && lng)) return
    setLocsearch(true)
    const waitForGoogle = () => {
      if (window.google && window.google.maps) {
        window.localStorage.setItem('locsearch', true)
        const address = {
          address: seraddress,
          location: {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          },
          utc_offset: (new Date()).getTimezoneOffset(),
          map_data: {
            library: 'google'
          }
        }
        formMethods.setValue('address', address.address)
        handleChangeAddress(address, true)
      } else {
        setTimeout(waitForGoogle, 300)
      }
    }

    waitForGoogle()
  }, [location.search])

  useEffect(() => {
    console.log('formState', formState?.changes?.address)
    if (formState?.changes?.address) {
      onSubmitGeolocation && onSubmitGeolocation()
    }
  }, [formState?.changes?.address])

  useEffect(() => {
    if (shouldFindBusiness && orderState?.options?.address?.location) {
      handleFindBusinesses()
      setShouldFindBusiness(false)
    }
  }, [orderState?.options?.address?.location, shouldFindBusiness])

  useEffect(() => {
    return () => setModals({ listOpen: false, formOpen: false })
  }, [])

  useEffect(() => {
    if (newAddressModalOpened) return
    if (auth && !sessionLoading && !orderState.loading && !orderState?.options?.address?.location) {
      setModals({ ...modals, listOpen: true })
      setNewAddressModalOpened(true)
    }
  }, [auth, orderState, sessionLoading, newAddressModalOpened])
  useEffect(() => {
    if(!window.sessionStorage.getItem('agevarification')){
      setAgeVarificationPop(true)
    }
  }, [window.sessionStorage.getItem('agevarification')])

  return (
    <>
    {locsearch === false && (
    <BlackContainer $bgImage={bottleBg} $bgMobile={bgmobile}>
      <MainSection>
        <HeroTitle>{t('BOTTLE_RUNNERS', 'Bottle Runners')}</HeroTitle>

        <SearchSection>
          <HeroSubtitle>{t('FIND_A_RUNNER', 'FIND A RUNNER')}</HeroSubtitle>
          <SearchWrap onClick={handleAddressInput}>
            <BiSearchAlt2 style={{ color: '#fff', fontSize: '1.4rem', marginRight: '15px' }} />
            <SearchInput
              placeholder={t('ORDER_NOW', 'Order Now')}
              readOnly
              value={orderState?.options?.address?.address || ''}
            />
          </SearchWrap>

          <GoogleGpsButtonHome
            className='gps-button'
            apiKey={googleMapsApiKey}
            isGetAddress={false}
            onData={(e) => {
              handleGpsGeocode(e.location)
            }}
            onError={setMapErrors}
            IconButton={MdLocationOn}
            IconLoadingButton={CgSearchLoading}
            CustomButton={
              <AddressUseLocation>
                <MdLocationOn /> {t('USE_MY_LOCATION', 'USE MY LOCATION')}
              </AddressUseLocation>
            }
          />
        </SearchSection>

        <ActionButtons>
          <CyanButton href='tel:+14372688537'>
            <FaPhoneAlt />
            {t('DIAL_A_BOTTLE', 'DIAL A BOTTLE')}
          </CyanButton>
          <CyanButton href='https://wa.me/14372688537'>
            <FaWhatsapp />
            {t('TEXT_US', 'TEXT US')}

          </CyanButton>
        </ActionButtons>
      </MainSection>
      {modals.cart && (
        <Modal
          title={t('CART', 'Cart')}
          open={modals.cart}
          onClose={() => setModals({ ...modals, cart: false })}
          width='700px'
        >
          <CartContent
            carts={carts}
            isOrderStateCarts={!!orderState.carts}
            onClose={() => setModals({ ...modals, cart: false })}
          />
        </Modal>
      )}
      {modals.address && (
        <Modal
          title={t('ADDRESS', 'Address')}
          open={modals.address}
          onClose={() => setModals({ ...modals, address: false })}
          width='70%'
        >
          <AddressList
            isModal
            changeOrderAddressWithDefault
            userId={isNaN(userCustomer) ? null : userCustomer}
            onCancel={() => setModals({ ...modals, address: false })}
            onAccept={() => handleFindBusinesses()}
          />
        </Modal>
      )}
      {modals.formOpen && (
        <Modal
          title={t('WHERE_DO_WE_DELIVERY', theme?.defaultLanguages?.WHERE_DO_WE_DELIVERY || 'Where do we delivery?')}
          open={modals.formOpen}
          onClose={() => setModals({ ...modals, formOpen: false })}
        >
          <AddressForm
            useValidationFileds
            address={orderState?.options?.address || {}}
            isGetAddress={isGPSAddress}
            onClose={() => { setModals({ ...modals, formOpen: false }); setIsGPSAddress(false) }}
            onSaveAddress={() => { setModals({ ...modals, formOpen: false }); setIsGPSAddress(false); setShouldFindBusiness(true); handleFindBusinesses() }}
            onCancel={() => { setModals({ ...modals, formOpen: false }); setShouldFindBusiness(true); handleFindBusinesses() }}
          />
        </Modal>
      )}
      {ageVarificationPop && (
        <Modal
          open={ageVarificationPop}
          hideCloseDefault
          closeOnBackdrop={false}
          onClose={() => setAgeVarificationPop(false)}
          // styled={{}}
          customStyle={{
            background: '#FFFFFF',

            // borderRadius: '10px',
            // padding: '20px',
          }}
          height='auto'
          width='600px'
        >
          <AgeVerificationWrapper>
            <img alt='Logotype' src={logoImg} loading='lazy' />
            <AgeVerificationTitle
            // style={{
            //   backgroundImage: `url(${logoImg})`
            // }}
            >{t('WELCOME_TO_BOTTLE_RUNNERS', 'WELCOME TO BOTTLE RUNNERS')}</AgeVerificationTitle>
            <AgeVerificationDesc>{t('WELCOME_TO_BOTTLE_RUNNERS_DESC', 'You must be 19 years old or older to access this site')}</AgeVerificationDesc>
            <AgeVerificationButton
              type='button'
              disabled={formState.loading}
              onClick={() => {
                window.sessionStorage.setItem('agevarification', 'true')
                setAgeVarificationPop(false)
              }}
            >
              {t('OLDER_BUTTON', 'Yes I am 19 or older')}
            </AgeVerificationButton>
          </AgeVerificationWrapper>
        </Modal>
      )}

      {modals.listOpen && (
        <Modal
          title={t('WHERE_DO_WE_DELIVERY', theme?.defaultLanguages?.WHERE_DO_WE_DELIVERY || 'Where do we delivery?')}
          open={modals.listOpen}
          width='70%'
          onClose={() => setModals({ ...modals, listOpen: false })}
        >
          <AddressList
            isModal
            changeOrderAddressWithDefault
            userId={isNaN(userCustomer) ? null : userCustomer}
            onCancel={() => setModals({ ...modals, listOpen: false })}
            onAccept={() => handleFindBusinesses()}
          />
        </Modal>
      )}
      {authModalOpen && !auth && (
        <Modal
          open={authModalOpen}
          onRemove={() => closeAuthModal()}
          width='50%'
          authModal
        >
          {modalPageToShow === 'login' && (
            <LoginForm
              notificationState={notificationState}
              handleSuccessLogin={handleSuccessLogin}
              elementLinkToSignup={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'signup' })
                  } href='#'
                >{t('CREATE_ACCOUNT', theme?.defaultLanguages?.CREATE_ACCOUNT || 'Create account')}
                </a>
              }
              elementLinkToForgotPassword={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'forgotpassword' })
                  } href='#'
                >{t('RESET_PASSWORD', theme?.defaultLanguages?.RESET_PASSWORD || 'Reset password')}
                </a>
              }
              useLoginByCellphone
              isPopup
            />
          )}
          {modalPageToShow === 'signup' && (
            <SignUpForm
              notificationState={notificationState}
              elementLinkToLogin={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'login' })
                  } href='#'
                >{t('LOGIN', theme?.defaultLanguages?.LOGIN || 'Login')}
                </a>
              }
              useLoginByCellphone
              useChekoutFileds
              handleSuccessSignup={handleSuccessSignup}
              isPopup
            />
          )}
          {modalPageToShow === 'forgotpassword' && (
            <ForgotPasswordForm
              elementLinkToLogin={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'login' })
                  } href='#'
                >{t('LOGIN', theme?.defaultLanguages?.LOGIN || 'Login')}
                </a>
              }
              isPopup
            />
          )}
        </Modal>
      )}
      <Alert
        title={t('ADDRESS', 'Address')}
        content={alertState.content}
        acceptText={t('ACCEPT', 'Accept')}
        open={alertState.open}
        onClose={() => closeAlert()}
        onAccept={() => closeAlert()}
        closeOnBackdrop={false}
      />
    </BlackContainer>
    )}
    </>
  )
}
export const HomeHero = (props) => {
  const googleMapsControls = {
    defaultZoom: 17,
    zoomControl: true,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeId: 'roadmap', // 'roadmap', 'satellite', 'hybrid', 'terrain'
    mapTypeControl: true,
    mapTypeControlOptions: {
      mapTypeIds: ['roadmap', 'satellite']
    },
    isMarkerDraggable: true
  }
  const homeHeroProps = {
    ...props,
    UIComponent: HomeHeroUI,
    googleMapsControls,
    isSelectedAfterAdd: true
  }

  return <AddressFormController {...homeHeroProps} />
}